import { render } from "./AuthForm.vue?vue&type=template&id=27a21002&scoped=true"
import script from "./AuthForm.vue?vue&type=script&lang=js"
export * from "./AuthForm.vue?vue&type=script&lang=js"

import "./AuthForm.vue?vue&type=style&index=0&id=27a21002&scoped=true&lang=css"

import exportComponent from "D:\\WebstormProjects\\authpage\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27a21002"]])

export default __exports__